import {getCookie, setCookie} from "../Plugins/Cookies";
import PageLoadedQueue from "../PageLoadedQueue";

/**
 * Save last visited category page in cookie
 */
export function setCategoryCookie(category: string) {
    setCookie('avency-nwd-shop-category-referrer', category);
}

/**
 * Get last visited category page from cookie
 */
export function getCategoryCookie() {
    return getCookie('avency-nwd-shop-category-referrer');
}

/**
 * Initialize category cookie event listener
 */
export function initCategoryCookieEventListener() {
    const categoryPage: HTMLElement = document.querySelector('.category-page');

    if (!categoryPage) {
        return;
    }

    document.addEventListener('click', function (e) {
        const isCategoryLink = (e.target as HTMLElement).closest('.category-page a')
            || (e.target as HTMLElement).closest('.shopping-button-dropup-popover a');

        if (!isCategoryLink) {
            return;
        }

        const categoryIdentifier = categoryPage.dataset.category;
        if (categoryIdentifier) {
            setCategoryCookie(categoryIdentifier);
        }
    }, {passive: false});
}

PageLoadedQueue.addFunction(initCategoryCookieEventListener);
